module.exports = __webpack_public_path__ + "static/img/26.257af602.png";